export class NoAccessError extends Error {}
